import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from '@apollo/client';

// Query to retrieve rioHost names
export var RIO_HOST_NAMES = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query RioHostNames {\n    rioHostNames {\n      gateway {\n        primaryHostName\n        secondaryHostName\n      }\n    }\n  }\n"])));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio2-web-client/dist/esm/queries/index.js
// module id = 4143
// module chunks = 11